/** Parcelas do acordo */
import React, { Component } from "react";
import PropTypes from "prop-types";
import api from "../../../../../../services/api";

import CurrencyField from "../../../../../../components/CurrencyField";

import * as MoneyFormater from "../../../../../../utils/MoneyFormater";
import * as DateFormater from "../../../../../../utils/DateFormater";
import { Button, Icon, Modal, notification, Tag } from "antd";
import * as Permissions from "../../../../../../services/permissions";
import { NotaFiscalParcela } from "./NotaFiscal";
import { isSuperUser } from "../../../../../../utils/is-superuser";
import { StatusHO } from "./StatusHO";
import { ValorHO } from "./ValorHO";

export default class Parcela extends Component {
  static propTypes = {
    parcela: PropTypes.object,
    acordo: PropTypes.object,
    handleUpdate: PropTypes.func
  };

  state = {
    valor_pago: this.props.parcela.valor_pago,
    data_pagamento: this.props.parcela.data_pagamento
      ? this.props.parcela.data_pagamento
      : "",
    editing: false,
    confirm_loading: false,
    recebido_loading: false,
    parcela: this.props.parcela
  };

  /**
   * Retorna o tipo, estilo e texto
   * do botão da parcela de acordo com o
   * status da parcela.
   */
  handleButton = () => {
    const status = this.props.acordo.status_acordo;
    const has_perm = Permissions.has("acordo.parcela_receber");
    let button = null;

    if (this.state.editing) {
      // Retorna os botões de confirmar e cancelar
      button = (
        <div>
          <Button
            loading={this.state.confirm_loading}
            size="small"
            className="btn btn-green"
            onClick={this.handleReceber}
          >
            {this.state.confirm_loading ? (
              ""
            ) : (
              <Icon style={{ color: "white" }} type="check" />
            )}
          </Button>
          &nbsp;&nbsp;
          <Button
            size="small"
            type="danger"
            disabled={this.state.confirm_loading}
            onClick={this.handleCancelClick}
          >
            <Icon type="close" />
          </Button>
        </div>
      );

      return button;
    }

    switch (String(status).toLocaleLowerCase()) {
      case "quitado":
        button = (
          <Button
            className="btn-green btn-green-ghost btn-quitado"
            ghost
            disabled
          >
            <b>QUITADO</b>
          </Button>
        );
        break;
      case "ativo":
        let status_parcela = this.state.parcela.status_parcela;

        if (status_parcela == "0") {
          button = (
            <Button
              type={this.isVencido() ? "danger" : "primary"}
              ghost
              onClick={this.handleParcelaReceiveClick}
              disabled={!has_perm} // Caso não tenha permissão, o botão ficará desabilitado
            >
              <b>RECEBER</b>
            </Button>
          );
        } else if (
          status_parcela === "1" &&
          this.state.parcela.status_conciliado === "NAO CONCILIADO"
        ) {
          button = (
            <div>
              <Button
                className="btn-green btn-green-ghost"
                ghost
                onClick={this.handleRecebidoClick}
                loading={this.state.recebido_loading}
                disabled={!has_perm} // Caso não tenha permissão, o botão ficará desabilitado
              >
                <b>RECEBIDO</b>
              </Button>
            </div>
          );
        } else if (status_parcela == "3") {
          button = (
            <div>
              <Button
                className="btn-green btn-green-ghost"
                ghost
                onClick={this.handleRecebidoClick}
                loading={this.state.recebido_loading}
                disabled={!has_perm} // Caso não tenha permissão, o botão ficará desabilitado
              >
                <b>RECEBIDO</b>
              </Button>
            </div>
          );
        } else {
          button = (
            <Button type="danger" ghost disabled>
              <b>CANCELADO</b>
            </Button>
          );
        }

        break;
      default:
        button = (
          <Button type="danger" ghost disabled>
            <b>REACORDO</b>
          </Button>
        );
        break;
    }
    return button;
  };

  /**
   * Atualiza o status da parcela paga PAGO,
   * atualiza o valor pago e a data de pagamento.
   */
  handleReceber = async () => {
    const valor = this.state.valor_pago;
    const data = this.state.data_pagamento;

    if (valor < 1) {
      Modal.error({
        title: "Error",
        content: "Valor inválido."
      });
      return;
    }

    if (data == null || data == "" || data.length < 1) {
      Modal.error({
        title: "Error",
        content: "Data de pagamento inválida."
      });
      return;
    }

    this.setState({
      confirm_loading: true
    });

    await api
      .put(`acordo/parcela/${this.state.parcela.id}/`, {
        status_parcela: "1", // Recebido
        valor_pago: valor,
        data_pagamento: data,
        data_vencimento: this.state.parcela.data_vencimento,
        num_parcela: this.state.parcela.num_parcela
      })
      .then(response => {
        const newdata = response.data;

        notification.success({
          message: "Parcela recebida."
        });

        this.setState({
          parcela: newdata
        });

        // Atualiza as informações do acordo
        this.props.handleUpdate();
      })
      .catch(err => {
        ////console.log(err);

        if (err.response) {
          if (err.response.status == 403) {
            Modal.error({
              title: "Error",
              content: "Sem permissão."
            });
            return;
          }
        }
        Modal.error({
          title: "Error",
          content: "Não foi possível atualizar a parcela."
        });
      });

    this.setState({
      confirm_loading: false,
      editing: false
    });
  };

  /**
   * Cancela o recebimento da parcela
   */
  handleCancelClick = () => {
    this.setState({
      editing: false,
      confirm_loading: false,
      valor_pago: 0,
      data_pagamento: ""
    });
  };

  /**
   * Libera os campos para edição do valor pago, e
   * data de pagamento.
   */
  handleParcelaReceiveClick = () => {
    const status = this.state.parcela.status_parcela;

    if (status == "0") {
      this.setState({
        editing: true,
        valor_pago: this.state.parcela.valor_parcela,
        data_pagamento: DateFormater.formatReverse(
          new Date().toLocaleDateString()
        )
      });
    }
  };

  handleValorPagoChange = value => {
    // Função chamada quando o usuário altera o valor do campo
    // de valor pago.
    this.setState({
      valor_pago: value
    });
  };

  handleDataPagamentoChange = event => {
    // Função chamada quando o usuário altera
    // o valor do campo de data pagamento.
    this.setState({
      data_pagamento: event.target.value
    });
  };

  /**
   * Calcula o valor dos honorários
   */
  handleCalcHonorarios = () => {
    const parcela_paga = this.state.parcela.status_parcela == "1";

    if (!parcela_paga) return "---";

    const valor_pago = this.state.parcela.valor_pago;
    const porc_honor = this.props.acordo.tipo_acordo.porcentagem_honorarios;

    const honorarios = (parseFloat(valor_pago) * parseFloat(porc_honor)) / 100;

    return `R$ ${MoneyFormater.format(honorarios)}`;
  };

  /** Verifica se a parcela está vencida */
  isVencido = () => {
    const now = new Date();
    const vencimento = DateFormater.toDate(this.state.parcela.data_vencimento);

    return vencimento < now;
  };

  /**
   * Mostra um modal perguntando se o usuário
   * deseja "despagar" a parcela.
   */
  handleRecebidoClick = () => {
    const modal = Modal.confirm();

    let parcela = {
      status_parcela: "0",
      data_pagamento: null,
      valor_pago: null,
      numero_nf: null,
      status_conciliado: "NAO CONCILIADO",
      data_vencimento: this.state.parcela.data_vencimento,
      num_parcela: this.state.parcela.num_parcela
    };

    modal.update({
      title: "Despagar parcela",
      content: "Deseja cancelar o pagamento dessa parcela?",
      onOk: () => {
        this.handleUpdateParcela(parcela);
      },
      onCancel: () => modal.destroy(),
      okText: "Confirmar",
      cancelText: "Cancelar"
    });
  };

  handleConciliarClick = () => {
    const modal = Modal.confirm();

    let parcela = {
      status_parcela: this.state.parcela.status_parcela,
      data_pagamento: this.state.data_pagamento,
      valor_pago: this.state.valor_pago,
      status_conciliado: "CONCILIADO",
      data_vencimento: this.state.parcela.data_vencimento,
      num_parcela: this.state.parcela.num_parcela
    };

    modal.update({
      title: "Conciliar parcela",
      content: "Deseja conciliar o pagamento dessa parcela?",
      onOk: () => {
        this.handleUpdateParcela(parcela);
      },
      onCancel: () => modal.destroy(),
      okText: "Confirmar",
      cancelText: "Cancelar"
    });
  };

  handleDesconciliarClick = () => {
    const modal = Modal.confirm();

    let parcela = {
      status_parcela: this.state.parcela.status_parcela,
      data_pagamento: this.state.data_pagamento,
      valor_pago: this.state.valor_pago,
      data_vencimento: this.state.parcela.data_vencimento,
      num_parcela: this.state.parcela.num_parcela,
      status_conciliado: "NAO CONCILIADO"
    };

    modal.update({
      title: "Conciliar parcela",
      content: "Deseja conciliar o pagamento dessa parcela?",
      onOk: () => {
        this.handleUpdateParcela(parcela);
      },
      onCancel: () => modal.destroy(),
      okText: "Confirmar",
      cancelText: "Cancelar"
    });
  };

  /**
   * Despaga uma parcela
   */
  handleUpdateParcela = async parcela => {
    this.setState({
      recebido_loading: true
    });

    await api
      .put(`acordo/parcela/${this.state.parcela.id}/`, parcela)
      .then(response => {
        const newdata = response.data;

        notification.success({
          message: "Pagamento da parcela atualizado."
        });
        //console.log("newData", newdata)
        this.setState({
          parcela: newdata,
          valor_pago: newdata.valor_pago == null ? 0 : newdata.valor_pago,
          data_pagamento:
            newdata.data_pagamento == null ? "" : newdata.data_pagamento
        });

        // Atualiza as informações do acordo
        this.props.handleUpdate();
      })
      .catch(err => {
        ////console.log(err);

        if (err.response) {
          if (err.response.status == 403) {
            Modal.error({
              title: "Error",
              content: "Sem permissão."
            });
            return;
          }
        }
        Modal.error({
          title: "Error",
          content: "Não foi possível atualizar a parcela. " + err
        });
      });

    this.setState({
      recebido_loading: false
    });
  };

  getEditing = () => {
    if (this.props.acordo.status_acordo == "ATIVO") {
      return true;
    }
    return false;
  };

  render() {
    const Button = this.handleButton();
    const isEntrada = this.state.parcela.num_parcela === 0;
    const isAdmin = isSuperUser();

    return (
      <tr
        className={
          this.state.parcela.status_parcela == "1"
            ? "pago"
            : this.isVencido()
            ? "vencido"
            : ""
        }
      >
        <td>
          <b>{isEntrada ? "Entrada" : `${this.state.parcela.num_parcela}º`}</b>
        </td>
        <td>R$ {MoneyFormater.format(this.state.parcela.valor_parcela)}</td>
        <td>{DateFormater.format(this.state.parcela.data_vencimento)}</td>
        <td>
          {isAdmin ? (
            <CurrencyField
              className="ant-input"
              name="valor_pago"
              onChangeEvent={this.handleValorPagoChange}
              innitialValue={this.state.parcela.valor_pago}
              value={this.state.valor_pago}
              disabled={!this.state.editing}
            />
          ) : (
            this.state.parcela.valor_pago ? `R$ ${MoneyFormater.format(this.state.parcela.valor_pago)}` : "---"
          )}
        </td>
        <td>
          <input
            type="date"
            className="ant-input"
            value={this.state.data_pagamento}
            disabled={!this.state.editing}
            onChange={this.handleDataPagamentoChange}
          />
        </td>
        <td>
          {this.state.parcela.forma_pagamento ? (
            <Tag color="blue">
              {this.state.parcela.forma_pagamento === "DEBITO_CONTA"
                ? "Débito em Conta"
                : this.state.parcela.forma_pagamento === "BOLETO_ASAAS"
                ? "Boleto Asaas"
                : this.state.parcela.forma_pagamento === "PIX"
                ? "PIX"
                : this.state.parcela.forma_pagamento === "DINHEIRO"
                ? "Dinheiro"
                : this.state.parcela.forma_pagamento === "CARTAO"
                ? "Cartão"
                : this.state.parcela.forma_pagamento === "OUTROS"
                ? "Outros"
                : this.state.parcela.forma_pagamento}
            </Tag>
          ) : (
            "---"
          )}
        </td>
        <td>
          {isAdmin ? (
            this.state.parcela.operador_nome ? (
              <span>{this.state.parcela.operador_nome}</span>
            ) : (
              "---"
            )
          ) : (
            "---"
          )}
        </td>
        <td className="parcela__button">{isAdmin ? Button : "---"}</td>
        <td>
          {isAdmin ? (
            <NotaFiscalParcela
              idParcela={this.state.parcela.id}
              initialValue={this.state.parcela.numero_nf}
              dataNF={this.state.parcela.data_nf}
              data={this.state.parcela}
            />
          ) : (
            this.state.parcela.numero_nf || "---"
          )}
        </td>
        <td>
          {isAdmin ? (
            <StatusHO
              data={this.state.parcela}
              idParcela={this.state.parcela.id}
              status={this.state.parcela.status_ho_contratual}
            />
          ) : (
            this.state.parcela.status_conciliado || "---"
          )}
        </td>
        <td>
          <ValorHO
            data={this.state.parcela}
            idParcela={this.state.parcela.id}
            valor={this.state.parcela.valor_ho_contratual}
          />
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Acordo/View/AcordoView/AcordoParcelas/Parcela/index.js